export default __webpack_public_path__ + "static/media/face_1_13.1eee6469.png";